document.addEventListener("DOMContentLoaded", (event) => {
	const industryFullCards = document.querySelectorAll(".industry-full-card");
	if (industryFullCards && industryFullCards.length > 0) {
		industryFullCards.forEach((card) => {
			const moreContent = card.querySelector(".more-content");
			if (!moreContent) return;
			if (moreContent.innerText === "") return;

			const btn = document.createElement("button");
			btn.setAttribute("type", "button");
			btn.className = "more-btn";
			btn.innerHTML = `<span>Read More</span>`;

			card.querySelector("& > .et_pb_group").appendChild(btn);
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				moreContent.classList.toggle("is-expanded");
				if (moreContent.classList.contains("is-expanded")) {
					btn.setAttribute("aria-expanded", true);
					btn.innerHTML = `<span>Collapse</span>`;
				} else {
					btn.setAttribute("aria-expanded", false);
					btn.innerHTML = `<span>Read More</span>`;
				}
			});
		});
	}
});
